import { Component } from '@angular/core';
import { ProductService } from '../../product.service';
import { IProduct, PRODUCT_TTL_ES } from '../../product.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';

@Component({
  selector: 'pg-product',
  templateUrl: './product.component.html'
})
export class ProductComponent extends CrudTemplate implements ICrudTemplate {
  constructor(private productService: ProductService) {
    super(PRODUCT_TTL_ES, productService);
  }

  ngOnInit() {
    this.table.settings = {
      title: PRODUCT_TTL_ES,
      columns: [
        { header: 'Código', field: 'itemCode' },
        { header: 'Descripción', field: 'itemName' },
        { header: 'Principio Activo', field: 'activesIngredients' },
        { header: 'Laboratorio', field: 'laboratoryDescription' },
        { header: 'Grupo Terapéutico', field: 'therapistGroups' },
        { header: 'Unidad de Medida', field: 'unitMeasureDescription' },
        { header: 'Símbolo de Medida', field: 'unitMeasureSymbol' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.productService
      .getData$()
      .subscribe((data: IProduct[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
